export const formatPostCode = (el, binding) => {
  if (binding.value) {
    el.innerText = binding.value.slice(0, 3) + "-" + binding.value.slice(3);
  }
};
